<template> 
   
     <router-view></router-view>
   
</template> 
<script>
   
    export default {
        name:'circles',
        data () {
            return {
             
            }
        },
        computed: {
       
        },
        methods: {
      
        },
        mounted: function(){
            var that = this;
          
        }
    }
</script>  
<style scoped>
    
</style>
     